<template>
    <span class="boolean-expression-wrapper" :class="{isRule: isRule, editMode: editMode, negated: isNegated}">
        <span v-if="!isEmpty && expression.negate" class="not-token">NOT</span>
        <span v-if="!isEmpty && expression.negate || !isRule" class="parent-token">(</span>
        <template v-if="isEmpty">
            <span v-if="!editMode"><i>empty</i></span>
            <button v-else type="button" class="edit-btn" @click="add"><i class="fa fa-plus"></i></button>
        </template>
        <template v-else-if="isRule">
            <span class="field-label">{{ expression.field_label }}</span>
            <span class="operator-label">{{ expression.operator_label }}</span>
            <span v-if="expression.rendered_values" class="rendered-label">{{ expression.rendered_values }}</span>
        </template>
        <template v-else>
            <template v-for="(nestedExpression, ix) in operands">
                <boolean-expression
                    :expression="nestedExpression"
                    :editMode="editMode"
                    @editExpression="editNestedExpression"
                    @addExpression="addNestedExpression"
                >
                </boolean-expression>
                <span v-if="ix < expressionLength - 1" class="boolean-connector">
                    <span v-if="isAnd">AND</span>
                    <span v-else-if="isOr">OR</span>
                </span>
            </template>
            <template v-if="editMode">
                <span v-if="expressionLength" class="boolean-connector">
                    <span v-if="isAnd">AND</span>
                    <span v-else-if="isOr">OR</span>
                </span>
                <button type="button" class="edit-btn" @click="add"><i class="fa fa-plus"></i></button>
            </template>
        </template>
        <span v-if="!isEmpty && expression.negate || !isRule" class="parent-token">)</span>
        <button class="edit-btn edit-btn-rule" v-if="!isEmpty && editMode" @click="edit"><i class="fa fa-pencil"></i></button>
    </span>
</template>
<script>
 
 
  export default {
      name: 'boolean-expression',
      components: {
      },
      props: {
          expression: {
              type: Object,
              default: null
          },
          editMode: {
              type: Boolean,
              default: false
          }
      },
      data () {
          return {
              editedExpression: null
          }
      },
      computed: {
          operands() {
              if (this.isAnd || this.isOr) {
                  return this.expression.operands.filter((x) => !x.hasOwnProperty('deleted') || !x.deleted);
              }
              return null;
          },
          expressionLength() { return this.operands != null ? this.operands.length : null },
          isEmpty() { return this.expression == null || this.expression.deleted },
          isRule() { return !this.isEmpty && this.expression.expression_type == 'rule'},
          isAnd() { return !this.isEmpty && this.expression.expression_type == 'and'},
          isOr() { return !this.isEmpty && this.expression.expression_type == 'or'},
          isNegated() { return !this.isEmpty && this.expression.negate }
      },
      methods: {
          edit() {
              this.$emit('editExpression', this.expression);
          },
          editNestedExpression(nestedExpression) {
              this.$emit('editExpression', nestedExpression)
          },
          add() {
              this.$emit('addExpression', this.expression);
          },
          addNestedExpression(nestedExpression) {
              this.$emit('addExpression', nestedExpression)
          },
      }
  }
</script>
<style lang="scss">
 @import "./static/css/_variables.scss";
 .boolean-expression-wrapper {
     line-height: 2.15rem;
     
     span + span {
         margin-left: .25rem;
     }

     &.isRule {
         padding: .25rem;;
         border-width: 1px;
         border-style: solid;
         border-radius: 4px 4px 4px 4px;
         background: #f4f4f4;
         border-color: #aeaeae;
     }

     &.negated {
         .not-token,
         .parent-token {
             color: red;
         }
     }

     &.editMode {
         display: inline-block;
         padding: .25rem;;
         border-width: 1px;
         border-style: dotted;
         border-color: #aeaeae;
         border-radius: 4px 4px 4px 4px;
         line-height: 2rem;

         &:hover {
             border-style: solid;
             border-color: $ls-action-highlight;
         }
     }

     .field-label {
         font-weight: 600;
         font-style: italic;
     }

     .rendered-label {
         font-weight: 600;
     }

     .edit-btn-rule {
         margin-top: -1rem;
         vertical-align: 30%;
     }
 }
</style>



// WEBPACK FOOTER //
// BooleanExpression.vue?6e308e8f